/**
 * MapViewControls Change Event Handlers
 *
 * Factory function that creates event handlers for MapViewControls toggle.
 * Handles click events on toggle buttons and updates the map type.
 *
 * Responsibilities:
 * - Convert user clicks into mapFacade.setMapType() calls
 * - Update control state for UI feedback
 * - Prevent default button behavior
 *
 * @module nativeInteractiveSiteMap/handlers/mapViewControlsHandlers
 */

import MapTypes from '../enums/mapTypes';

export default function createMapViewControlsHandlers(setMapType, updateControlState) {
  function setMapTypeLocal(mapType) {
    if (typeof setMapType !== 'function') {
      return;
    }
    setMapType(mapType.toString());
  }

  /**
   * Handles Road button click.
   * Updates map to road map type.
   */
  const onRoadClick = () => {
    // Update map facade
    setMapTypeLocal(MapTypes.Roadmap);

    // Update control state
    if (updateControlState) {
      updateControlState(MapTypes.Roadmap);
    }
  };

  /**
   * Handles Satellite button click.
   * Updates map to satellite map type.
   */
  const onSatelliteClick = () => {
    // Update map facade
    setMapTypeLocal(MapTypes.Satellite);

    // Update control state
    if (updateControlState) {
      updateControlState(MapTypes.Satellite);
    }
  };

  return {
    onRoadClick,
    onSatelliteClick,
  };
}
